import React, { useEffect } from 'react';

import { Outlet, useNavigate } from 'react-router-dom';

const ProtectedRoute: React.FC = () => {
  const navigate = useNavigate();
  const isAuthenticated = true; //useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      // Redirect to the login page
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  if (isAuthenticated) {
    return <Outlet />;
  }

  // Return null if not authenticated to prevent rendering anything
  return null;
};

export default ProtectedRoute;
